import { env } from "./env";

export type RuntimeConfig = {
  keycloakUrl?: string;
  keycloakRealm?: string;
  keycloakClientId?: string;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

/**
 * Prefer pod-injected `/runtime-config.js` (per-stage Keycloak). Fall back to
 * bake-time Vite env for `npm run dev` and images that have not yet been
 * redeployed with the runtime endpoint.
 */
export const getRuntimeConfig = (): RuntimeConfig => {
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }

  return {};
};

export const resolveKeycloakUrl = (): string => {
  const fromRuntime = getRuntimeConfig().keycloakUrl?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  return env.VITE_KEYCLOAK_URL;
};

export const resolveKeycloakRealm = (): string => {
  const fromRuntime = getRuntimeConfig().keycloakRealm?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  return env.VITE_KEYCLOAK_REALM;
};

export const resolveKeycloakClientId = (): string => {
  const fromRuntime = getRuntimeConfig().keycloakClientId?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  return env.VITE_KEYCLOAK_CLIENT_ID;
};
